import { useAtom } from 'jotai'
import { purchaseTypeAtom } from '@!/atoms/paymentAtom'
import { CoinPaymentHeader } from './CoinPaymentHeader'
import { MonthlyPaymentHeader } from './MonthlyPaymentHeader'

export const PaymentHeader = () => {
  const [purchaseType] = useAtom(purchaseTypeAtom)

  if (purchaseType === 'coin') {
    return <CoinPaymentHeader />
  }

  if (purchaseType === 'monthly') {
    return <MonthlyPaymentHeader />
  }

  return null
}
